// Only original messages in one group and below the server cutoff are invalidated.
export function mergeMessageRemovalCutoffs(current = {}, payload = {}) {
  const next = { ...current };
  if (!payload || typeof payload !== 'object') return next;
  const cutoff = Number(payload.maxMessageId);
  if (!Number.isSafeInteger(cutoff) || cutoff <= 0 || !Array.isArray(payload.userIds)) return next;
  payload.userIds.forEach(userId => {
    const id = Number(userId);
    if (Number.isSafeInteger(id) && id > 0) next[String(id)] = Math.max(Number(next[String(id)]) || 0, cutoff);
  });
  return next;
}

export function isRemovedMemberMessage(message, cutoffs = {}) {
  if (!message) return false;
  const id = Number(message.id);
  const cutoff = Number(cutoffs[String(message.sendId)]);
  return Number.isSafeInteger(id) && id > 0 && cutoff > 0 && id <= cutoff;
}

export function applyGroupMessageRemoval(message, cutoffs = {}) {
  if (!message) return false;
  const type = Number(message.type);
  const original = (type >= 0 && type < 10) || (type >= 40 && type < 50);
  if (original && isRemovedMemberMessage(message, cutoffs)) {
    message.content = '';
    message.status = 2;
    message.type = 10;
    message.recallTombstone = true;
    message.quoteMessage = null;
    message.quoteMessageId = null;
    message.atUserIds = [];
    message.receipt = false;
    message.receiptOk = false;
    Object.keys(message).forEach(key => {
      if (key.startsWith('localPreview') || key.startsWith('localAsset')) delete message[key];
    });
    return true;
  }
  if (message.quoteMessage && isRemovedMemberMessage(message.quoteMessage, cutoffs)) {
    const quote = message.quoteMessage;
    if (quote.status === 2 && quote.content === '{"key":"tip.recall.quote"}') return false;
    message.quoteMessage = {
      id: quote.id, sendId: quote.sendId, sendNickName: quote.sendNickName,
      type: 21, status: 2, content: '{"key":"tip.recall.quote"}'
    };
    return true;
  }
  return false;
}
